import { render, staticRenderFns } from "./SavedPropertyCard.vue?vue&type=template&id=247623d8"
import script from "./SavedPropertyCard.vue?vue&type=script&lang=ts"
export * from "./SavedPropertyCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports